export default {
  openConfirmationWindow: function(title, confirmationMessage, okCallback, cancelCallback) {
    kendo
      .jQuery('<div/>')
      .kendoConfirm({
        title,
        content: confirmationMessage,
      })
      .getKendoConfirm()
      .open()
      .result.done(okCallback)
      .fail(cancelCallback)
  },
}
